import { normalizePaymentOffset } from "~/utils/paymentExtension.js"

export default defineNuxtPlugin((nuxtApp) => {
	const { $eventApiService } = useNuxtApp()
	const eventStore = useEventStore()

	nuxtApp.provide("eventService", {
		$getLatestPaymentOffset: async (eventId) => {
			const successHandler = (res) => {
				const offset = res.data.offset
				const event = eventStore.getEventById(eventId)
				if (event) event.latestPaymentDueDateOffset = normalizePaymentOffset(offset)
			}

			await $eventApiService.$getLatestPaymentOffset(eventId, successHandler)
		},
	})
})
